import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";

const RecommendationDetail = ({ ccoRecommendation }) => {

    return(<>
         <AccordianContainer
          id="accord"
          title="CCO Recommendation Details"
          initialOpen={false}
        >
        <Box sx={{ marginTop: "-1%" }}>
          <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Internal Application ID"
                variant="standard"
                placeholder="Enter Internal Application ID"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.internalApplicationId : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="File Action"
                variant="standard"
                placeholder="Enter File Action"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.fileAction : ""}
              />
              </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Application Number"
                variant="standard"
                placeholder="Enter Application Number"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.applicationNumber : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Wish List"
                variant="standard"
                placeholder="Enter Wish List"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.wishlist : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Remarks"
                variant="standard"
                placeholder="Enter Remarks"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.remarks : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Tenure (Months)"
                variant="standard"
                placeholder="Enter Tenure (Months)"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.tenureInMonths : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="EMI Value"
                variant="standard"
                placeholder="Enter EMI Value"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.emiValue : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="ROI"
                variant="standard"
                placeholder="Enter ROI"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.roi : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Sanctioned Condition"
                variant="standard"
                placeholder="Enter Sanctioned Condition"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.sanctionedCondition : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Sanctioned Loan Amount"
                variant="standard"
                placeholder="Enter Sanctioned Loan Amount"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.sanctionedLoanAmount : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Rejection Count"
                variant="standard"
                placeholder="Enter Rejection Count"
                disabled={true}
                value={ccoRecommendation !== undefined ? ccoRecommendation.rejectionCount : ""}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
             <CustomTextField
                type="text"
                label="Sanction Date"
                variant="standard"
                placeholder="Enter Sanction Date"
                disabled={true}
                value={validate(ccoRecommendation) ? convertDateWithValidation(ccoRecommendation.sanctionDate) : ""}
              />
              </Grid>
              </Grid>
              </Box>
        </AccordianContainer>
    </>);

}

export default RecommendationDetail;